import Service 			from "./../../Libs/Service";
import _ from "lodash";

import { ScreenService }	from "./Screen";

let Elements = new Service({

	Name: "Elements",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Selected Version Switched": function() {

			this.selectElement(null);

		},

		"Selected Version Element Property Changed": function(newProps, oldProps, changedKeys, options) {

			_.each(changedKeys, propertyCodename => {

				Broadcast.call("Send To iFrame", [{
					ElementProperty: {
						screenCodename: options.element['screen_codename'],
						elementCodename: options.element.codename,
						propertyName: propertyCodename,
						propertyValue: newProps[propertyCodename],
						sizeKey: options.sizeKey
					}
				}]);

			});

		},

		// Превью должно знать актуальные options элементов (например, importantElement для отправки HitElement при закрытом редакторе)
		"Selected Version Element Changed: [options]": function(element) {

			if (!element) return;

			Broadcast.call("Send To iFrame", [{
				ElementOptions: [element['screen_codename'], element.codename, element.options]
			}]);

		},

		// Добавление, удаление элементов и смена иерархии должны доходить до превью, даже когда вкладка
		// с деревом элементов закрыта (например, ассет перетащили во фрейм): сообщения отправляет сервис,
		// а элемент берётся с текущего экрана дашборда (ScreenService.getCurrentScreen)
		"Selected Version Element Added": function(element) {

			if (element?.['screen_codename'] !== ScreenService.getCurrentScreen()?.codename) return;

			Broadcast.call("Send To iFrame", [{
				ElementCreated: {
					screenCodename: element['screen_codename'],
					element: element
				}
			}]);

		},

		"Selected Version Element Removed": function(element) {

			if (element?.['screen_codename'] !== ScreenService.getCurrentScreen()?.codename) return;

			Broadcast.call("Send To iFrame", [{
				ElementDeleted: {
					screenCodename: element['screen_codename'],
					elementCodename: element.codename
				}
			}]);

		},

		"Element Changed: [parent|priority]": function(element) {

			if (element?.['screen_codename'] !== ScreenService.getCurrentScreen()?.codename) return;

			Broadcast.call("Send To iFrame", [{
				ElementHierarchy: {
					screenCodename: element['screen_codename'],
					elementCodename: element.codename,
					parent: element.parent,
					priority: element.priority
				}
			}]);

		},

	},

	Actions: {

		// Получение всех экранов креатива или версии (serverId - нода, с которой пришли данные)
		"Elements": function(elements, data, size, serverId) {

			if (data.ElementsCreativeId) {

				this.setElements(elements, serverId);

				// Первоначальная загрузка экранов всех версий креатива
				Broadcast.call("Creative Elements Loaded", [data.ElementsCreativeId]);

			} else if (data.ElementsVersionId) {

				this.setElements(elements, serverId);

				// Первоначальная загрузка экранов одной версии (дублирование версии или создание из шаблона)
				Broadcast.call("Version Elements Loaded", [data.ElementsVersionId]);

			}

		},

		// Получение всех экранов креатива или версии
		"ElementsHash": function(elements, data, size, serverId) {

			// 2022.07.23 важно сначала обновить весь кэш и только потом вызывать события иначе при переименовании дочерний элемент
			// не найдёт своего родителя (нужно сначала оба объекта изменить и только потом вызывать события изменения)
			let oldElements = {},
				elementsByHierarchy = this.getServerMap(this.ElementsByHierarchyByServer, serverId || this.NodeServerId);

			_.each(elements, (element, elementCodename) => {

				oldElements[elementCodename] = elementsByHierarchy[data['ElementsHashVersionId']]?.[data['ElementsHashScreenCodename']]?.[elementCodename];

				this.setElement(data['ElementsHashVersionId'], data['ElementsHashScreenCodename'], elementCodename, element, serverId);

			});

			_.each(elements, (element, elementCodename) => {

				this.detectElementChanges(oldElements[elementCodename], element);

			});

		},

		"Element": function(element, data, size, serverId) {

			let elementsByHierarchy = this.getServerMap(this.ElementsByHierarchyByServer, serverId || this.NodeServerId),
				oldElement = elementsByHierarchy[data.ElementVersionId]?.[data.ElementScreenCodename]?.[data.ElementCodename];

			this.setElement(data.ElementVersionId, data.ElementScreenCodename, data.ElementCodename, element, serverId);

			this.detectElementChanges(oldElement, element);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и элементов
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.ElementsByVersionByServer = {};
		this.ElementsByHierarchyByServer = {};

		this.globalElement = {codename: '#global', type: 'global', options: {}};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (ElementsByVersion[versionId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.ElementsByVersion = this.getServerMap(this.ElementsByVersionByServer, serverId);
		this.ElementsByHierarchy = this.getServerMap(this.ElementsByHierarchyByServer, serverId);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setElements(versionsElements, serverId) {

		serverId = serverId || this.NodeServerId;

		let elementsByVersion = this.getServerMap(this.ElementsByVersionByServer, serverId),
			elementsByHierarchy = this.getServerMap(this.ElementsByHierarchyByServer, serverId);

		_.each(versionsElements, (versionElements, versionId) => {

			elementsByVersion[versionId] = versionElements;
			elementsByHierarchy[versionId] = _.mapValues(_.groupBy(Object.values(versionElements), 'screen_codename'), objs => _.keyBy(objs, 'codename'));

		});

	},

	setElement(versionId, screenCodename, elementCodename, element, serverId) {

		serverId = serverId || this.NodeServerId;

		let elementsByVersion = this.getServerMap(this.ElementsByVersionByServer, serverId),
			elementsByHierarchy = this.getServerMap(this.ElementsByHierarchyByServer, serverId);

		if (element) {

			elementsByVersion[versionId][element.id] = element;
			elementsByHierarchy[versionId][screenCodename][elementCodename] = element;

			if (serverId === this.NodeServerId && elementCodename === this.SelectedElement?.codename) this.SelectedElement = element;

		} else {

			const el = elementsByHierarchy[versionId]?.[screenCodename]?.[elementCodename];

			if (el) {
				delete elementsByVersion[versionId][el.id];
				delete elementsByHierarchy[versionId][screenCodename][elementCodename];
			}

		}

	},

	detectElementChanges(oldElement, newElement) {

		let eventPrefixes = ["Element"];
		if (newElement?.codename === this.SelectedElement?.codename || oldElement?.codename === this.SelectedElement?.codename) eventPrefixes.push("Selected Element");
		if (newElement?.["version_id"] === Version.SelectedVersion?.id || oldElement?.["version_id"] === Version.SelectedVersion?.id) eventPrefixes.push("Selected Version Element");

		this.broadcastChanges(oldElement, newElement, eventPrefixes, {excludeKeys: ['props']});

		eventPrefixes = ["Element Property"];
		if (newElement?.codename === this.SelectedElement?.codename || oldElement?.codename === this.SelectedElement?.codename) eventPrefixes.push("Selected Element Property");
		if (newElement?.["version_id"] === Version.SelectedVersion?.id || oldElement?.["version_id"] === Version.SelectedVersion?.id) eventPrefixes.push("Selected Version Element Property");

		if (oldElement && newElement) {

			_.each(oldElement.props, (props, sizeKey) => {

				if (newElement.props[sizeKey]) {

					this.broadcastChanges(oldElement.props[sizeKey], newElement.props[sizeKey], eventPrefixes, {element: newElement, sizeKey});

				}

			});

		}

	},

	getVersionElements(version) {

		return this.ElementsByVersion[version.id] || {};

	},

	getVersionElementsByScreen(version) {

		return this.ElementsByHierarchy[version.id] || {};

	},

	// Важный элемент текущей версии (помечен options.importantElement) - подсвечивается в дереве,
	// а по наведению в превью для него показываются кнопки быстрой замены ассета или текста
	getImportantElement(screenCodename, elementCodename) {

		if (!Version.SelectedVersion) return null;

		let element = this.getVersionElementsByScreen(Version.SelectedVersion)[screenCodename]?.[elementCodename];

		return element?.options?.importantElement ? element : null;

	},

	selectElement(element) {

		this.SelectedElement = element;

		Broadcast.call("Selected Element Switched", [this.SelectedElement]);

	},

	getVersionElementsTreeList(version, screenCodename, dashboardExpanded = {}) {

		let elements = _.cloneDeep(this.getVersionElementsByScreen(version));
		let screenElements = _.values(elements[screenCodename]);
		let screenElementsByCodename = elements[screenCodename];

		//удаляем старые ссылки на дочерние элементы
		_.each(screenElements, element => {

			delete element.childs;

		});

		//формируем древовидную структуру (вставляем дочерние элементы в родителей)
		_.each(screenElements, element => {

			if (element.parent) {

				let parent = screenElementsByCodename[element.parent];
				if (!parent) {
					console.warn(`End Card build error: There are no parent element with id = ${element.parent}`);
					parent = screenElements[0];
				}

				if (!parent.childs) parent.childs = [];
				parent.childs.push(element);

			}

		});

		//сортируем дочерние элементы
		_.each(screenElements, element => {

			if (element.childs) element.childs = _.sortBy(element.childs, 'priority');

		});

		// В дерево попадает и сам рутовый контейнер (сцена) - он всегда верхний, а всё остальное находится внутри него
		return this.extractTreeToList(_.sortBy(_.filter(screenElements, o => !o.parent), 'priority'), dashboardExpanded, [], 0);

	},

	extractTreeToList(elements, dashboardExpanded = {}, result = [], offset = 0) {

		_.each(elements, element => {

			element._offset = offset;

			result.push(element);

			let expandedKey = `${element['version_id']}-${element['screen_codename']}-${element['codename']}`;

			if (element.childs && dashboardExpanded[expandedKey] !== false) this.extractTreeToList(element.childs, dashboardExpanded, result, offset + 1);

		});

		return result;

	},

	forEachAllChilds(element, fn) {

		_.each(element.childs, child => {

			fn(child);

			if (child.childs) this.forEachAllChilds(child, fn);

		});

	}

});

window.Elements = Elements;

export { Elements }

